import { Component } from '@angular/core';

@Component({
  selector: 'app-create-company',
  template: `
    <p>
      create-company works!
    </p>
  `,
  styles: ``
})
export class CreateCompanyComponent {

}
